export const GOODS_URL = {
  ctgNo: '/goods?ctgNo=',
};
